import { getAdDimensions } from './imaSdkUtils.ts';
import { VideoPlayer } from './VideoPlayer.tsx';
import { VideoPlayerWithControls } from './VideoPlayerWithControls.tsx';

type PreviewVideoProps = {
  adMarkup: string;
  onClose: () => void;
  showControls?: boolean;
};

export function PreviewVideo({ adMarkup, onClose, showControls = false }: PreviewVideoProps) {
  const [width, height] = getAdDimensions();

  if (showControls) {
    return <VideoPlayerWithControls adMarkup={adMarkup} onClose={onClose} width={width} height={height} />;
  }

  return <VideoPlayer adMarkup={adMarkup} onClose={onClose} width={width} height={height} />;
}
